/**
 * Core API
 * Core API.
 *
 * The version of the OpenAPI document: 1.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { NotificacionRoleModel } from '../model/notificacionRoleModel';
// @ts-ignore
import { NotificacionesModel } from '../model/notificacionesModel';
// @ts-ignore
import { PageNotificacionesModel } from '../model/pageNotificacionesModel';
// @ts-ignore
import { Pageable } from '../model/pageable';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable()
export class NotificacionControllerService {

    protected basePath = 'https://devenvanet.envalora.es';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }

    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param id 
     * @param roles 
     * @param id2 
     * @param fechaDesde 
     * @param fechaHasta 
     * @param mensaje 
     * @param usuarioModificacion 
     * @param fechaModificacion 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public actualizarNotificacion(id: number, roles: Array<'AD_ADHERIDO' | 'ADM_COMUNICACIONES' | 'AG_GESTOR' | 'AG_POSEEDOR' | 'DE_ADHERIDO' | 'PO_GESTOR' | 'PO_POSEEDOR' | 'PR_GESTOR' | 'PR_PUNTORECOGIDA' | 'SDDR_CC' | 'SDDR_CA' | 'PO_APORT_AUTOFACT' | 'AD_ENV_CONS' | 'AD_ENV_GEST' | 'AG_ENV_CONS' | 'AG_ENV_GEST' | 'DE_ENV_CONS' | 'DE_ENV_GEST' | 'PO_ENV_CONS' | 'PO_ENV_GEST' | 'PR_ENV_CONS' | 'PR_ENV_GEST' | 'SDDR_CA_ENV_CONS' | 'SDDR_CA_ENV_GEST' | 'SDDR_CC_ENV_CONS' | 'SDDR_CC_ENV_GEST'>, id2?: number, fechaDesde?: string, fechaHasta?: string, mensaje?: string, usuarioModificacion?: string, fechaModificacion?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<NotificacionesModel>;
    public actualizarNotificacion(id: number, roles: Array<'AD_ADHERIDO' | 'ADM_COMUNICACIONES' | 'AG_GESTOR' | 'AG_POSEEDOR' | 'DE_ADHERIDO' | 'PO_GESTOR' | 'PO_POSEEDOR' | 'PR_GESTOR' | 'PR_PUNTORECOGIDA' | 'SDDR_CC' | 'SDDR_CA' | 'PO_APORT_AUTOFACT' | 'AD_ENV_CONS' | 'AD_ENV_GEST' | 'AG_ENV_CONS' | 'AG_ENV_GEST' | 'DE_ENV_CONS' | 'DE_ENV_GEST' | 'PO_ENV_CONS' | 'PO_ENV_GEST' | 'PR_ENV_CONS' | 'PR_ENV_GEST' | 'SDDR_CA_ENV_CONS' | 'SDDR_CA_ENV_GEST' | 'SDDR_CC_ENV_CONS' | 'SDDR_CC_ENV_GEST'>, id2?: number, fechaDesde?: string, fechaHasta?: string, mensaje?: string, usuarioModificacion?: string, fechaModificacion?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<NotificacionesModel>>;
    public actualizarNotificacion(id: number, roles: Array<'AD_ADHERIDO' | 'ADM_COMUNICACIONES' | 'AG_GESTOR' | 'AG_POSEEDOR' | 'DE_ADHERIDO' | 'PO_GESTOR' | 'PO_POSEEDOR' | 'PR_GESTOR' | 'PR_PUNTORECOGIDA' | 'SDDR_CC' | 'SDDR_CA' | 'PO_APORT_AUTOFACT' | 'AD_ENV_CONS' | 'AD_ENV_GEST' | 'AG_ENV_CONS' | 'AG_ENV_GEST' | 'DE_ENV_CONS' | 'DE_ENV_GEST' | 'PO_ENV_CONS' | 'PO_ENV_GEST' | 'PR_ENV_CONS' | 'PR_ENV_GEST' | 'SDDR_CA_ENV_CONS' | 'SDDR_CA_ENV_GEST' | 'SDDR_CC_ENV_CONS' | 'SDDR_CC_ENV_GEST'>, id2?: number, fechaDesde?: string, fechaHasta?: string, mensaje?: string, usuarioModificacion?: string, fechaModificacion?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<NotificacionesModel>>;
    public actualizarNotificacion(id: number, roles: Array<'AD_ADHERIDO' | 'ADM_COMUNICACIONES' | 'AG_GESTOR' | 'AG_POSEEDOR' | 'DE_ADHERIDO' | 'PO_GESTOR' | 'PO_POSEEDOR' | 'PR_GESTOR' | 'PR_PUNTORECOGIDA' | 'SDDR_CC' | 'SDDR_CA' | 'PO_APORT_AUTOFACT' | 'AD_ENV_CONS' | 'AD_ENV_GEST' | 'AG_ENV_CONS' | 'AG_ENV_GEST' | 'DE_ENV_CONS' | 'DE_ENV_GEST' | 'PO_ENV_CONS' | 'PO_ENV_GEST' | 'PR_ENV_CONS' | 'PR_ENV_GEST' | 'SDDR_CA_ENV_CONS' | 'SDDR_CA_ENV_GEST' | 'SDDR_CC_ENV_CONS' | 'SDDR_CC_ENV_GEST'>, id2?: number, fechaDesde?: string, fechaHasta?: string, mensaje?: string, usuarioModificacion?: string, fechaModificacion?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling actualizarNotificacion.');
        }
        if (roles === null || roles === undefined) {
            throw new Error('Required parameter roles was null or undefined when calling actualizarNotificacion.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (roles) {
            roles.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'roles');
            })
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (BearerAuthentication) required
        localVarCredential = this.configuration.lookupCredential('BearerAuthentication');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        var body:any = {};
        if (id2 !== undefined) {
            localVarFormParams = localVarFormParams.append('id', <any>id2) as any || localVarFormParams;
            body.id = id2;
        }
        if (fechaDesde !== undefined) {
            localVarFormParams = localVarFormParams.append('fechaDesde', <any>fechaDesde) as any || localVarFormParams;
            body.fechaDesde = fechaDesde;
        }
        if (fechaHasta !== undefined) {
            localVarFormParams = localVarFormParams.append('fechaHasta', <any>fechaHasta) as any || localVarFormParams;
            body.fechaHasta = fechaHasta;
        }
        if (mensaje !== undefined) {
            localVarFormParams = localVarFormParams.append('mensaje', <any>mensaje) as any || localVarFormParams;
            body.mensaje = mensaje;
        }
        if (usuarioModificacion !== undefined) {
            localVarFormParams = localVarFormParams.append('usuarioModificacion', <any>usuarioModificacion) as any || localVarFormParams;
            body.usuarioModificacion = usuarioModificacion;
        }
        if (fechaModificacion !== undefined) {
            localVarFormParams = localVarFormParams.append('fechaModificacion', <any>fechaModificacion) as any || localVarFormParams;
            body.fechaModificacion = fechaModificacion;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/core/notificaciones/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<NotificacionesModel>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: body, //localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public eliminarNotificacion(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext}): Observable<NotificacionesModel>;
    public eliminarNotificacion(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext}): Observable<HttpResponse<NotificacionesModel>>;
    public eliminarNotificacion(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext}): Observable<HttpEvent<NotificacionesModel>>;
    public eliminarNotificacion(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*', context?: HttpContext}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling eliminarNotificacion.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (BearerAuthentication) required
        localVarCredential = this.configuration.lookupCredential('BearerAuthentication');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                '*/*'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/core/notificaciones/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<NotificacionesModel>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param pageable 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findAll2(pageable: Pageable, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<PageNotificacionesModel>;
    public findAll2(pageable: Pageable, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<PageNotificacionesModel>>;
    public findAll2(pageable: Pageable, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<PageNotificacionesModel>>;
    public findAll2(pageable: Pageable, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling findAll2.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (pageable !== undefined && pageable !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pageable, 'pageable');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (BearerAuthentication) required
        localVarCredential = this.configuration.lookupCredential('BearerAuthentication');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/core/notificaciones/listar-todos`;
        return this.httpClient.request<PageNotificacionesModel>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findAllByUser(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<NotificacionesModel>>;
    public findAllByUser(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<NotificacionesModel>>>;
    public findAllByUser(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<NotificacionesModel>>>;
    public findAllByUser(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (BearerAuthentication) required
        localVarCredential = this.configuration.lookupCredential('BearerAuthentication');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/core/notificaciones`;
        return this.httpClient.request<Array<NotificacionesModel>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findAllRoles(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<NotificacionRoleModel>>;
    public findAllRoles(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<NotificacionRoleModel>>>;
    public findAllRoles(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<NotificacionRoleModel>>>;
    public findAllRoles(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling findAllRoles.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (BearerAuthentication) required
        localVarCredential = this.configuration.lookupCredential('BearerAuthentication');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/core/notificaciones/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/roles`;
        return this.httpClient.request<Array<NotificacionRoleModel>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param roles 
     * @param id 
     * @param fechaDesde 
     * @param fechaHasta 
     * @param mensaje 
     * @param usuarioModificacion 
     * @param fechaModificacion 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public subirNotificacion(roles: Array<'AD_ADHERIDO' | 'ADM_COMUNICACIONES' | 'AG_GESTOR' | 'AG_POSEEDOR' | 'DE_ADHERIDO' | 'PO_GESTOR' | 'PO_POSEEDOR' | 'PR_GESTOR' | 'PR_PUNTORECOGIDA' | 'SDDR_CC' | 'SDDR_CA' | 'PO_APORT_AUTOFACT' | 'AD_ENV_CONS' | 'AD_ENV_GEST' | 'AG_ENV_CONS' | 'AG_ENV_GEST' | 'DE_ENV_CONS' | 'DE_ENV_GEST' | 'PO_ENV_CONS' | 'PO_ENV_GEST' | 'PR_ENV_CONS' | 'PR_ENV_GEST' | 'SDDR_CA_ENV_CONS' | 'SDDR_CA_ENV_GEST' | 'SDDR_CC_ENV_CONS' | 'SDDR_CC_ENV_GEST'>, id?: number, fechaDesde?: string, fechaHasta?: string, mensaje?: string, usuarioModificacion?: string, fechaModificacion?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<NotificacionesModel>;
    public subirNotificacion(roles: Array<'AD_ADHERIDO' | 'ADM_COMUNICACIONES' | 'AG_GESTOR' | 'AG_POSEEDOR' | 'DE_ADHERIDO' | 'PO_GESTOR' | 'PO_POSEEDOR' | 'PR_GESTOR' | 'PR_PUNTORECOGIDA' | 'SDDR_CC' | 'SDDR_CA' | 'PO_APORT_AUTOFACT' | 'AD_ENV_CONS' | 'AD_ENV_GEST' | 'AG_ENV_CONS' | 'AG_ENV_GEST' | 'DE_ENV_CONS' | 'DE_ENV_GEST' | 'PO_ENV_CONS' | 'PO_ENV_GEST' | 'PR_ENV_CONS' | 'PR_ENV_GEST' | 'SDDR_CA_ENV_CONS' | 'SDDR_CA_ENV_GEST' | 'SDDR_CC_ENV_CONS' | 'SDDR_CC_ENV_GEST'>, id?: number, fechaDesde?: string, fechaHasta?: string, mensaje?: string, usuarioModificacion?: string, fechaModificacion?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<NotificacionesModel>>;
    public subirNotificacion(roles: Array<'AD_ADHERIDO' | 'ADM_COMUNICACIONES' | 'AG_GESTOR' | 'AG_POSEEDOR' | 'DE_ADHERIDO' | 'PO_GESTOR' | 'PO_POSEEDOR' | 'PR_GESTOR' | 'PR_PUNTORECOGIDA' | 'SDDR_CC' | 'SDDR_CA' | 'PO_APORT_AUTOFACT' | 'AD_ENV_CONS' | 'AD_ENV_GEST' | 'AG_ENV_CONS' | 'AG_ENV_GEST' | 'DE_ENV_CONS' | 'DE_ENV_GEST' | 'PO_ENV_CONS' | 'PO_ENV_GEST' | 'PR_ENV_CONS' | 'PR_ENV_GEST' | 'SDDR_CA_ENV_CONS' | 'SDDR_CA_ENV_GEST' | 'SDDR_CC_ENV_CONS' | 'SDDR_CC_ENV_GEST'>, id?: number, fechaDesde?: string, fechaHasta?: string, mensaje?: string, usuarioModificacion?: string, fechaModificacion?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<NotificacionesModel>>;
    public subirNotificacion(roles: Array<'AD_ADHERIDO' | 'ADM_COMUNICACIONES' | 'AG_GESTOR' | 'AG_POSEEDOR' | 'DE_ADHERIDO' | 'PO_GESTOR' | 'PO_POSEEDOR' | 'PR_GESTOR' | 'PR_PUNTORECOGIDA' | 'SDDR_CC' | 'SDDR_CA' | 'PO_APORT_AUTOFACT' | 'AD_ENV_CONS' | 'AD_ENV_GEST' | 'AG_ENV_CONS' | 'AG_ENV_GEST' | 'DE_ENV_CONS' | 'DE_ENV_GEST' | 'PO_ENV_CONS' | 'PO_ENV_GEST' | 'PR_ENV_CONS' | 'PR_ENV_GEST' | 'SDDR_CA_ENV_CONS' | 'SDDR_CA_ENV_GEST' | 'SDDR_CC_ENV_CONS' | 'SDDR_CC_ENV_GEST'>, id?: number, fechaDesde?: string, fechaHasta?: string, mensaje?: string, usuarioModificacion?: string, fechaModificacion?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (roles === null || roles === undefined) {
            throw new Error('Required parameter roles was null or undefined when calling subirNotificacion.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (roles) {
            roles.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'roles');
            })
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (BearerAuthentication) required
        localVarCredential = this.configuration.lookupCredential('BearerAuthentication');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }
        
        var body:any = {};
        if (id !== undefined) {
            localVarFormParams = localVarFormParams.append('id', <any>id) as any || localVarFormParams;
            body.id = id;
        }
        if (fechaDesde !== undefined) {
            localVarFormParams = localVarFormParams.append('fechaDesde', <any>fechaDesde) as any || localVarFormParams;
            body.fechaDesde = fechaDesde;
        }
        if (fechaHasta !== undefined) {
            localVarFormParams = localVarFormParams.append('fechaHasta', <any>fechaHasta) as any || localVarFormParams;
            body.fechaHasta = fechaHasta;
        }
        if (mensaje !== undefined) {
            localVarFormParams = localVarFormParams.append('mensaje', <any>mensaje) as any || localVarFormParams;
            body.mensaje = mensaje;
        }
        if (usuarioModificacion !== undefined) {
            localVarFormParams = localVarFormParams.append('usuarioModificacion', <any>usuarioModificacion) as any || localVarFormParams;
            body.usuarioModificacion = usuarioModificacion;
        }
        if (fechaModificacion !== undefined) {
            localVarFormParams = localVarFormParams.append('fechaModificacion', <any>fechaModificacion) as any || localVarFormParams;
            body.fechaModificacion = fechaModificacion;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/core/notificaciones`;
        return this.httpClient.request<NotificacionesModel>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: body, //localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
